import { PDFDocument } from 'pdf-lib'
import download from 'downloadjs';

async function fillForm() {

  switch(document.documentElement.lang) {
    case 'it-IT':
      var form_id = 3;
      var pdfname = '02_Alphera_IT_Accordo.pdf?v=2';
      var pdflink = 'contratto-di-delega.pdf';
    break;
    case 'fr-FR':
      var form_id = 2;
      var pdfname = '02_Alphera_FR_Convention.pdf?v=2';
      var pdflink = 'accord-de-delegation.pdf';
    break;
    default:
      var form_id = 1;
      var pdfname = '02_Alphera_DE_Delegationsvereinbarung.pdf?v=2';
      var pdflink = 'delegationsvereinbarung.pdf';
    break;
  }

  // Fetch the PDF with form fields
  const formUrl = window.location.origin + '/wp-content/uploads/' + pdfname
  const formPdfBytes = await fetch(formUrl).then(res => res.arrayBuffer())

  // Load a PDF with form fields
  const pdfDoc = await PDFDocument.load(formPdfBytes)

  // Get the form containing all the fields
  const form = pdfDoc.getForm()

  var inputName = $('#input_'+form_id+'_8').val();
  var inputAdresse = $('#input_'+form_id+'_9').val();
  var inputPLZ = $('#input_'+form_id+'_10').val()+' '+$('#input_'+form_id+'_11').val();

  var today = new Date();
  var dd = today.getDate();
  
  var mm = today.getMonth()+1; 
  var yyyy = today.getFullYear();
  if(dd<10) 
  {
      dd='0'+dd;
  } 
  
  if(mm<10) 
  {
      mm='0'+mm;
  } 
  const datum = 'Dielsdorf, '+dd+'.'+mm+'.'+yyyy;

  // Get all fields in the PDF by their names
  const nameField = form.getTextField('firmenname')
  const adressField = form.getTextField('adresse')
  const plzField = form.getTextField('ort')
  const datumField = form.getTextField('ort_datum')
  //const haendlerField = form.getTextField('haendler')

  // Fill in the basic info fields
  nameField.setText(inputName)
  adressField.setText(inputAdresse)
  plzField.setText(inputPLZ)
  datumField.setText(datum)

  // Serialize the PDFDocument to bytes (a Uint8Array)
  const pdfBytes = await pdfDoc.save()

  // Trigger the browser to download the PDF document
  download(pdfBytes, pdflink, "application/pdf");
}

/*$(document).ready(function() {
	$('a.download-pdf').click(function() {
		console.log('Click');
		console.log(inputName,inputAdresse,inputPLZ,inputHanedler);
		fillForm(inputName,inputAdresse,inputPLZ,inputHanedler);
	});
	$(document).on('gform_post_render', function (event, form_id, current_page) {
		console.log('HALLO WELT');
	});
	$(document).on('gform_page_loaded', function(event, form_id, current_page){
		console.log(current_page);
        $('a.download-pdf').click(fillForm);
    });
});*/

window.fillForm = fillForm;
